/**
 * Socket event names for Planning Poker
 */
export enum SocketEvent {
  // Connection events
  JOIN_SESSION = 'join_session',
  LEAVE_SESSION = 'leave_session',
  SESSION_JOINED = 'session_joined',
  USER_LEFT = 'user_left',

  // Voting events
  CAST_VOTE = 'cast_vote',
  VOTE_CAST = 'vote_cast',
  VOTES_COUNT = 'votes_count',

  // Round management
  REQUEST_REVEAL = 'request_reveal',
  ROUND_REVEALED = 'round_revealed',
  START_ROUND = 'start_round',
  ROUND_STARTED = 'round_started',
  PARTICIPANTS_UPDATE = 'participants_updated',

  // Participant management
  BLOCK_PARTICIPANT = 'block_participant',
  UNBLOCK_PARTICIPANT = 'unblock_participant',
  REMOVE_PARTICIPANT = 'remove_participant',
  READD_PARTICIPANT = 'readd_participant',

  // Session management
  SET_TIMER = 'set_timer',
  TIMER_EXPIRED = 'timer_expired',
  SET_FINAL_ESTIMATE = 'set_final_estimate',
  SESSION_CLOSED = 'session_closed',
  SESSION_CONFIGURATION_UPDATED = 'session_configuration_updated', // NEW

  // BillShuffle / social events
  SHUFFLE_ASSIGN = 'shuffle_assign',
  ASSIGNMENT_RESULT = 'assignment_result',
  ADD_FRIEND = 'add_friend',
  REMOVE_FRIEND = 'remove_friend',
  FRIENDS_UPDATE = 'friends_update',

  // Misc / Live
  LIVE_MESSAGE = 'LIVE_MESSAGE',
  SEND_LIVE_MESSAGE = 'SEND_LIVE_MESSAGE',

  // Error handling
  ERROR = 'error',
  RECONNECTED = 'reconnected',
  // NEW: Advanced timing events
  SET_ADVANCED_TIMER = 'set_advanced_timer',
  ADVANCED_TIMER_SET = 'advanced_timer_set',
  TIMER_TICK = 'timer_tick',
  TIMER_WARNING = 'timer_warning',
  PAUSE_TIMER = 'pause_timer',
  RESUME_TIMER = 'resume_timer',
  EXTEND_TIMER = 'extend_timer',
  TIMER_PAUSED = 'timer_paused',
  TIMER_RESUMED = 'timer_resumed',
  TIMER_EXTENDED = 'timer_extended',
  PARTICIPANT_TIMER_START = 'participant_timer_start',
  PARTICIPANT_TIMER_EXPIRED = 'participant_timer_expired',
  AUTO_REVEAL_VOTES = 'auto_reveal_votes',
  AUTO_CLOSE_SESSION = 'auto_close_session',
  SCHEDULE_SESSION = 'schedule_session',
  SESSION_SCHEDULED = 'session_scheduled',
  SCHEDULED_START_REMINDER = 'scheduled_start_reminder',
  SCHEDULED_SESSION_STARTED = 'scheduled_session_started',
  VOTING_SPEED_UPDATE = 'voting_speed_update',
  ROUND_TIMING_SUMMARY = 'round_timing_summary',
  GET_TIMER_STATUS = 'get_timer_status',
  TIMER_STATUS_UPDATE = 'timer_status_update',
  BULK_TIMER_STATUS = 'bulk_timer_status'

}

/**
 * Planning session status
 */
export enum SessionStatus {
  OPEN = 'open',
  IN_PROGRESS = 'in_progress',
  PAUSED = 'paused',
  REVEALED = 'revealed',
  CLOSED = 'closed',
  EXPIRED = 'expired',
  SCHEDULED = 'scheduled', // Added SCHEDULED status
  DISCUSSION = 'discussion'
}

/**
 * User roles in planning session
 */
export enum UserRole {
  SUPER_ADMIN = 'superadmin',
  ADMIN = 'admin',
  HOST = 'host',
  USER = 'user',
  GUEST = 'guest',
}

/**
 * Export formats
 */
export enum ExportFormat {
  JSON = 'json',
  CSV = 'csv'
}

/**
 * Vote deck types
 */
export enum DeckType {
  FIBONACCI = 'fibonacci',
  MODIFIED_FIBONACCI = 'modified_fibonacci',
  POWER_OF_2 = 'power_of_2',
  T_SHIRT = 't_shirt',
  LINEAR_SCALE = 'linear_scale',
  DOUBLING_SEQUENCE = 'doubling_sequence',

  // Qualitative
  RISK_LEVELS = 'risk_levels',
  CONFIDENCE_LEVELS = 'confidence_levels',
  TIME_BASED = 'time_based',

  // Fun / Alternative
  EMOJI_DECK = 'emoji_deck',
  PLAYING_CARDS = 'playing_cards',
  TACO_SCALE = 'taco_scale',
  STORY_POINTS = 'story_points',
  SMALL_MEDIUM_LARGE = 'small_medium_large',
  BINARY = 'binary',
  PRIORITY_SCALE = 'priority_scale',
  CONFIDENCE_NUMBERS = 'confidence_numbers',
  EMOJI_SENTIMENT = 'emoji_sentiment',

  // Custom
  CUSTOM = 'custom'
}

/**
 * Assignment methods for BillShuffle
 */
export enum AssignmentMethod {
  RANDOM_SHUFFLE = 'random_shuffle',
  WEIGHTED_RANDOM = 'weighted_random',
  ROUND_ROBIN = 'round_robin',
  HOST_SELECT = 'host_select'
}


export enum SessionMode {
  PLANNING_POKER = 'planning_poker',
  BILL_SHUFFLE = 'bill_shuffle',
  CANDIDATE_VOTING = 'candidate_voting',
  IDEA_RANKING = 'idea_ranking',
  FEATURE_PRIORITIZATION = 'feature_prioritization',
  POLL_SURVEY = 'poll_survey',
  TASK_ASSIGNMENT = 'task_assignment'
}